// The default Material UI dialog is literally unusable on small screens.
// This component attempts to fix some of the problems.
// The code and the scss are taken from here:
// https://gist.github.com/ThadeuLuz/0fafd4b44682df34ac807ebbd051a6f8
// following this issue:
// https://github.com/callemall/material-ui/issues/3295
// --viktor@2017-10-16

import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import './responsive_dialog.scss';

export default function ResponsiveDialog(props) {
  // Setting a default empty title here because if no title is provided
  // the content is not offset at all and it looks bad. --viktor@2017-10-16
  return (
    <Dialog
      title=""

      {...props}

      repositionOnUpdate={false}
      autoDetectWindowHeight={false}
      autoScrollBodyContent={false}
      className="dialog-root"
      contentClassName="dialog-content"
      bodyClassName="dialog-body"
    >
      <div className="dialog-scroll">
        {props.children}
      </div>
    </Dialog>
  );
}

ResponsiveDialog.propTypes = {
  children: PropTypes.node,
};

ResponsiveDialog.defaultProps = {
  children: null,
};



// WEBPACK FOOTER //
// ./src/components/responsive_dialog/responsive_dialog.jsx